<app-configuration-page
  title="Calendar Configuration"
  description="Configure how your studio calendar looks and behaves: its colors, display options, and event editing."
  [breadcrumbs]="[{ label: 'Calendar Configuration' }]">

  <mat-tab-group class="calendar-config-tabs" animationDuration="200ms" mat-stretch-tabs="false"
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Display Settings">
      <div class="calendar-config-tab-body">
        <app-calendar-display-settings></app-calendar-display-settings>
      </div>
    </mat-tab>

    <mat-tab label="Working Hours">
      <div class="calendar-config-tab-body">
        <mat-card class="configuration-card">
          <mat-card-header>
            <mat-card-title>Working Hours</mat-card-title>
            <mat-card-subtitle>Set the hours your studio is open for lessons and appointments.</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <app-form-studio-working-hours></app-form-studio-working-hours>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Session Start Times">
      <div class="calendar-config-tab-body">
        <mat-card class="configuration-card">
          <mat-card-header>
            <mat-card-title>Session Start Times</mat-card-title>
            <mat-card-subtitle>Define the specific times lessons can be scheduled each day.</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <app-session-start-times></app-session-start-times>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Colors">
      <div class="calendar-config-tab-body">
        <app-calendar-color-form></app-calendar-color-form>
      </div>
    </mat-tab>
  </mat-tab-group>

</app-configuration-page>
